import {
  DEFAULT_GRID_PREFERENCE,
  sanitizeGridPreference,
  applyColumnOrder,
  JobsColumnsPopover,
} from '../jobs/JobsColumnsHelper';

export const GRID_PREFERENCES_STORAGE_KEY = 'remindersGridPreferences';
export const SECTION_HEIGHTS_STORAGE_KEY = 'remindersSectionHeights';

export const DEFAULT_SECTION_HEIGHT = 400;
export const MIN_SECTION_HEIGHT = 200;
export const MAX_SECTION_HEIGHT = 900;

export const REMINDER_SECTION_KEYS = ['pendingJobs'];

export { DEFAULT_GRID_PREFERENCE, sanitizeGridPreference, applyColumnOrder };
export const RemindersColumnsPopover = JobsColumnsPopover;

export const parseGridPreferences = () => {
  const stored = window.localStorage.getItem(GRID_PREFERENCES_STORAGE_KEY);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch {
      // fall through to migration
    }
  }

  // Migrate column prefs from the old Requests page storage key
  try {
    const legacyStored = window.localStorage.getItem('requestsGridPreferences');
    if (legacyStored) {
      const legacy = JSON.parse(legacyStored);
      if (legacy?.pendingJobs) {
        return { pendingJobs: legacy.pendingJobs };
      }
    }
  } catch {
    // ignore
  }

  return {};
};

export const parseSectionHeights = () => {
  const stored = window.localStorage.getItem(SECTION_HEIGHTS_STORAGE_KEY);
  let parsed = null;

  if (stored) {
    try {
      parsed = JSON.parse(stored);
    } catch {
      parsed = null;
    }
  }

  if (!parsed || typeof parsed !== 'object') {
    // Migrate section height from the old Requests page storage key
    try {
      const legacyStored = window.localStorage.getItem('requestsSectionHeights');
      if (legacyStored) {
        const legacy = JSON.parse(legacyStored);
        if (legacy?.pendingJobs != null) {
          parsed = { pendingJobs: legacy.pendingJobs };
        }
      }
    } catch {
      parsed = null;
    }
  }

  if (!parsed || typeof parsed !== 'object') return {};

  return REMINDER_SECTION_KEYS.reduce((acc, key) => {
    const value = Number(parsed[key]);
    if (Number.isFinite(value)) {
      acc[key] = Math.min(MAX_SECTION_HEIGHT, Math.max(MIN_SECTION_HEIGHT, value));
    }
    return acc;
  }, {});
};

export const clampSectionHeight = (height) => {
  const value = Number(height);
  if (!Number.isFinite(value)) return DEFAULT_SECTION_HEIGHT;
  return Math.min(MAX_SECTION_HEIGHT, Math.max(MIN_SECTION_HEIGHT, value));
};
